module.exports = __webpack_public_path__ + "65e75ebf3489bcc09d701ddb04aaecde.svg";